import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://api2.mescout.org/api/'
});

export default instance;


// WEBPACK FOOTER //
// ./src/axios-orders.js